
import { useState, useEffect } from "react";

interface UseTableColumnsProps {
  tableId: string;
  defaultColumns: string[];
}

export function useTableColumns({ tableId, defaultColumns }: UseTableColumnsProps) {
  const storageKey = `table-columns-${tableId}`;
  
  // Initialize state with stored preferences or defaults
  const [selectedColumns, setSelectedColumns] = useState<string[]>(() => {
    if (typeof window !== 'undefined') {
      const storedColumns = localStorage.getItem(storageKey);
      return storedColumns ? JSON.parse(storedColumns) : defaultColumns;
    }
    return defaultColumns;
  });

  // Save to localStorage when column selection changes
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(selectedColumns));
  }, [selectedColumns, storageKey]);

  const updateSelectedColumns = (columns: string[]) => {
    setSelectedColumns(columns);
  };

  return {
    selectedColumns,
    updateSelectedColumns
  };
}
